module.exports = __webpack_public_path__ + "static/img/img_9.e8937f6f.png";